import type { DomainMainMenuItem, LangCode } from '@creator/sdk/modules/config/config.model';
import { getFrontendFunctionsBaseUrl } from '@src/config';
import creatorSdk from '@src/services/creator-sdk';
import { deepMerge } from '@src/utils/object-utils/object-utils';
import en from '../../config/domain/lang/en';

export async function loadDomainLanguage(lang: LangCode): Promise<{ [key: string]: string }> {
    return creatorSdk.configModule.getDomainLanguage(lang);
}

export async function loadLanguage(lang: LangCode): Promise<typeof en> {
    const domainLang = window.__SSR_DATA__.i18n ? window.__SSR_DATA__.i18n : await loadDomainLanguage(lang);
    return deepMerge(en, domainLang);
}

export async function updateMenu(menu: DomainMainMenuItem[]) {
    const authToken = await creatorSdk.accountModule.getIdToken();

    const response = await fetch(`${getFrontendFunctionsBaseUrl()}/main-menu`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
            'x-forwarded-host': window.location.host,
        },
        body: JSON.stringify(menu),
    });

    const data = await response.json();

    if (!response.ok) throw new Error(data.error || 'Failed to save menu');

    return data.data;
}
